import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { getPresignedUploadUrl } from '../redux/actions/chatRealtime';
import { validateChatFile } from '../common/chatUploads';
import { useR2Upload } from './useR2Upload';

/**
 * Sube un archivo del chat a R2 con URL prefirmada y lo mantiene en el
 * compositor hasta que el usuario envía o descarta el mensaje.
 */
export const useChatAttachment = (courseId) => {
    const dispatch = useDispatch();

    const requestPresign = useCallback((file, mimeType) => {
        if (!courseId) {
            return Promise.reject(new Error('No hay curso activo.'));
        }
        return dispatch(getPresignedUploadUrl(courseId, {
            fileName: file.name,
            mimeType,
            size: file.size,
        }));
    }, [courseId, dispatch]);

    return useR2Upload({
        validateFile: validateChatFile,
        requestPresign,
    });
};
